import React from 'react'

import { TabButton } from './TabButton'
import { BoxPricesTabsProps } from './boxPricesTabsModels'

import css from './BoxPricesTabs.css'

export const BoxPricesTabs = ({ labels, activeIndex, setActiveIndex }: BoxPricesTabsProps) => (
  <div className={css.tabs}>
    {labels.map((label, index) => (
      <TabButton
        key={label}
        text={label}
        isActive={activeIndex === index}
        onClick={() => setActiveIndex(index)}
      />
    ))}
  </div>
)
